import React from "react";
import { Heading, Text, Popover } from "@cisco/spaces-dash-lib-styleguide";

export const rolesFormatter = (data, title) => {
  if (data.getValue() !== undefined) {
    const { length } = data.renderValue();
    if (data.renderValue().length > 3) {
      return (
        <>
          <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
            {data
              .renderValue()
              .slice(0, 3)
              .map((ele, index) => {
                if (index === 2) return <li key={ele}>{ele}</li>;
                return <li key={ele}>{ele},</li>;
              })}
          </ul>
          <Popover
            title={
              <ul style={{ listStyleType: "none", padding: 10, margin: 0 }}>
                <Heading size="xs">{title}</Heading>
                {data.renderValue().map((ele, index) =>
                  index === length - 1 ? (
                    <li key={ele}>
                      <Text size="p3">{ele}</Text>
                    </li>
                  ) : (
                    <li key={ele}>
                      <Text size="p3">{ele},</Text>
                    </li>
                  )
                )}
              </ul>
            }
            placement="bottom"
            size="lg"
          >
            <Text color="#00bceb" size="p3" className="hover-target" style={{ cursor: "pointer", width: "fit-content" }}>
              +{length - 3} more
            </Text>
          </Popover>
        </>
      );
    }
    return (
      <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
        {data.renderValue().map((ele, index) =>
          index === length - 1 ? (
            <li key={ele}>
              <Text size="p3">{ele}</Text>
            </li>
          ) : (
            <li key={ele}>
              <Text size="p3">{ele},</Text>
            </li>
          )
        )}
      </ul>
    );
  }
  return data.renderValue();
};
